import React from 'react';
import { EmployeeModal } from './EmployeeModal';

interface EmployeeFormModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
  title: string;
}

export const EmployeeFormModal: React.FC<EmployeeFormModalProps> = ({
  visible,
  onCancel,
  onSubmit
}) => {
  const handleSuccess = () => {
    onSubmit({});
    onCancel();
  };

  return (
    <EmployeeModal
      open={visible}
      employee={null}
      onSuccess={handleSuccess}
      onCancel={onCancel}
    />
  );
};

export default EmployeeFormModal;
